import { CustomLink } from '@ygtechnologies/bygr-frontend-component-library';
import { createDataTable } from '@/components/DataTable';
import React, { useState } from 'react';
import { BygrProjectDetails, ProjectMember, ProjectMemberSource } from '@/types';
import { showModules } from '@/utils/util';
// import theme from './ProjectMembers.module.scss';

interface ProjectMembersProps {
    project: BygrProjectDetails;
}
const MemberDataTable = createDataTable<ProjectMember>();

const ProjectMembers: React.FC<ProjectMembersProps> = ({ project }) => {
    const [memberTableState, setMemberTableState] = useState(MemberDataTable.getInitialState('userId'));

    return (
        <MemberDataTable
            hasPagination={false}
            data={project.members}
            onStateChange={setMemberTableState}
            state={memberTableState}
            totalItemCount={project.members.length}
            className="table style-3">
            <MemberDataTable.Column header="User Id" field="userId" renderer={({ value }) => value} />
            <MemberDataTable.Column
                header="User Name"
                field="userName"
                renderer={({ value, row }) => (
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                        <CustomLink to={`/users/${row.userId}`}>{value}</CustomLink>
                        {row.source === ProjectMemberSource.Inherited && (
                            <span
                                title="Global member — added by a parent profile's admin to span this organization's projects. Removing them here keeps them out of this project even if the parent admin re-applies global access later."
                                style={{
                                    background: '#eef',
                                    color: '#225',
                                    padding: '2px 8px',
                                    borderRadius: 4,
                                    fontSize: 11,
                                    fontWeight: 700,
                                    letterSpacing: 0.3,
                                    cursor: 'help',
                                }}>
                                🌐 GLOBAL
                            </span>
                        )}
                    </span>
                )}
            />
            <MemberDataTable.Column
                header="Profile"
                field="profileName"
                renderer={({ value, row }) => <CustomLink to={`/profiles/${row.profileId}`}>{value}</CustomLink>}
            />
            <MemberDataTable.Column header="Module" field="bygrModules" renderer={({ value }) => showModules(value)} />
            <MemberDataTable.Column header="Owner" field="isOwner" renderer={({ value }) => (value ? 'Yes' : 'No')} />
            <MemberDataTable.Column
                header="Cm Admin"
                field="isCmAdministrator"
                renderer={({ value }) => (value ? 'Yes' : 'No')}
            />
            <MemberDataTable.Column
                header="Am Admin"
                field="isAmAdministrator"
                renderer={({ value }) => (value ? 'Yes' : 'No')}
            />
            <MemberDataTable.Column
                header="Qm Admin"
                field="isQmAdministrator"
                renderer={({ value }) => (value ? 'Yes' : 'No')}
            />
        </MemberDataTable>
    );
};

export default ProjectMembers;
